import { useState, useEffect, useRef } from "react";
import "../login/Login.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import GgLogo from "../../assets/img/logo gg.png";
import { useFetch } from "../../Services/useFetch";
import { Button, Form, Input } from "antd";
const initialState = {
  username: "",
  password: "",
};

const SignUp = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [data, setData] = useState(initialState);
  const emailInputRef = useRef(null);
  const [loader, setLoader] = useState(false);

  const [disableBtn, setDisableBtn] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const handleCheckMsg = () => {
    const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (data.username.length === 0) {
      setMessage("");
    }
    if (data.username !== "") {
      if (emailRegex.test(data.username)) {
        setMessage("");
      } else {
        setMessage("Please enter a valid email!");
      }
    }
  };

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    handleCheckMsg();
  }, [data?.username]);

  useEffect(() => {
    setDisableBtn(false);
  }, [data.username, data.password]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <Notification /> */}
      <div className="login_body">
        <div className="formWarpper">
          <div className="loginLogo">
            <img src={GgLogo} onClick={() => navigate(`/briefcase`)} width={60} alt="" />
          </div>
          <div className="section-title text-center">
            <h1>
              Doc Grid Register User <span className="one-text"></span>
            </h1>
          </div>
          <div className="errormessagename" style={{ color: "red" }}>
            {errorMessage}
          </div>

          <Form form={form} name="control-hooks" layout="vertical" autoComplete="off">
            <Form.Item label="Name:" name="name" rules={[{ required: true, message: "Name is required" }]}>
              <Input placeholder="Enter here" />
            </Form.Item>

            <Form.Item label="Email:" name="email" rules={[{ required: true, message: "Email is required" }]}>
              <Input placeholder="Enter here" />
            </Form.Item>

            <Form.Item label="Phone:" name="phone" rules={[{ required: true, message: "Phone No. is required" }]}>
              <Input placeholder="Enter here" />
            </Form.Item>

            <Form.Item label="Password:" name="password" rules={[{ required: true, message: "Password is required" }]}>
              <Input placeholder="Enter here" />
            </Form.Item>

            <Form.Item
              label="Confirm Password:"
              name="confirm_password"
              rules={[{ required: true, message: "Confirm Password is required" }]}
            >
              <Input placeholder="Enter here" />
            </Form.Item>

            <div className="sign_profile_button">
              <Button className="profile_submit" type="primary" htmlType="submit">
                Register
              </Button>
            </div>
          </Form>
        </div>
        <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default SignUp;
